import { ecbrRequest } from '../../request/ecbrRequest'

export const coupons = {
  getAll: async (...[params, ...rest]) =>
    ecbrRequest.get('/coupon', { params }, ...rest),
  create: async (coupon) => ecbrRequest.post('/coupon', coupon),
  update: async (id, coupon) => ecbrRequest.put(`/coupon/${id}`, coupon),
  validateCoupon: async (coupon) =>
    ecbrRequest.get(`/coupon/validate/${coupon}`),
  existsByCode: async (code) => ecbrRequest.get(`/coupon/exists/${code}`)
}
